module.exports = __webpack_public_path__ + "static/how-to-apply-trucker-2ec3ab543fca0759e54c11811c3084b0.jpg";